<template>
    <div class="section-post-creator">
        <header>
            <div class="container-title">
                <div class="btn-back" @click="$router.push('/dash/posts2');"></div>
                <div class="text">
                    <h2 class="title">{{title}}</h2>
                    <!-- <p class="switchOldVersion" @click="assignUsers">Assigner pour validation{{ idUsersAssigned.length ? `(${idUsersAssigned.length})` : '' }}</p> -->
                    <p v-if="!previewMode.active && ['create','duplicate'].includes(mode) && canRestoreDraft" class="switchOldVersion" @click="$emit('retoreDraftInLocalStorage')">{{ $t('dash.post-creator.action.restore-draft') }}</p>
                    <p v-else-if="mode !== 'create'" class="switchOldVersion" @click="$router.push('/dash/posts2');">{{ $t('dash.post-creator.back-to-planner') }}</p>
                </div>
            </div>

            <div class="btns-action">
               
                <template v-if="!previewMode.active">

                    <template  v-if="formData.planifiedDate.date" >
                        <div v-if="isCurrentUserAssigned" class="btn assign" @click="unassignCurrentUser">
                            {{ $t('dash.post-creator.user.unassign') }}
                            <i class="fa-solid fa-user-minus"></i>
                        </div>
                        <div v-else class="btn assign" @click="assignUsers">
                            {{ $t('dash.post-creator.user.assign') }} {{ idUsersAssigned.length ? `(${idUsersAssigned.length})` : '' }}
                        <i class="fa-solid fa-user-plus"></i>
                    </div>
                    </template>
                    
                    <Tooltip 
                        :text="$t('dash.post-creator.media.uploading')"
                        :active="isFileUploading"
                        position="bottom"
                    >   
                        <div class="btn-outline-primary" v-if="mode !== 'update' && !(formData.planifiedDate.date && idUsersAssigned.length && requiredValidation)" :class="{disable: isFileUploading}" @click="saveDraft">{{ { create: $t('dash.post-creator.action.save-draft'), duplicate: $t('dash.post-creator.action.save-draft'), edit: $t('dash.post-creator.action.convert-to-draft'), draft: $t('dash.post-creator.action.save') }[mode || 'create'] }}</div>
                    </Tooltip>
                    <Tooltip 
                        :text="$t('dash.post-creator.media.uploading')"
                        :active="isFileUploading"
                        position="bottom"
                    >   
                        <div 
                            class="btn-secondary icon-r" 
                            :class="{disable : isFileUploading || !pagesValidForPreview.length}" 
                            @click="()=>handlerChangePreviewDisplay(true)">
                            {{ textSwitchPreview }}
                            <i class="fa-solid fa-arrow-right"></i>
                        </div>
                    </Tooltip>
                </template>

                <template v-else>
                    <div class="btn-outline-primary" @click="()=>handlerChangePreviewDisplay(false)">{{ $t('dash.button.go_back') }}</div>
                    <div class="btn-secondary icon-r" :class="{disable : isFileUploading || !pagesValidForPreview.length}" @click="sendPostAllPost">{{textBtnFinish}}<i class="fa-solid fa-arrow-right"></i></div>
                </template>
                
            
            </div>
        </header>
        <div :class="'post-creator '+formShow" ref="postCreator" >
            <div class="container-form" v-if="formShow == 'formMultiple'">
                <div class="nav-type-post">
                    <!-- <div class="icon-l" @click.stop="switchTab"><i class="fa-solid fa-pen-to-square"></i>Standard</div> -->
                    <!-- <div v-if="tab == 'story_share'" class="icon-l btn-primary"><i class="fa-solid fa-share-from-square"></i>Partage en story</div> -->
                    <div class="icon-l" :class="{['btn-primary'] : tab == 'story'}"><i class="fa-solid fa-camera-retro"></i>Story</div>
                </div>

                <div class="container-form-scroll hide-scrollbar">
                    <div class="form">
                        <div class="list-pages-selected hide-scrollbar">
                            <div v-if="tab == 'story' && !draftInstance.pages.length" class="btn-add-page" @click="openSelectPage">
                                <i class="fa-solid fa-plus"></i>
                                <p>{{ $t('dash.post-creator.pages.add') }}</p>
                            </div>
                            <template v-else >
                                <div class="btn-all-container" v-if="draftInstance.pages.length > 1 ">
                                    <div 
                                        :class="['btn-all', 'unselectable-all', {checked: draftInstance.form.merge.target == 'main'}]" 
                                        @click="()=>draftInstance.form.merge.run('main')"
                                    >
                                        <i class="fa-solid fa-users"></i>
                                        <p>Tous</p>
                                    </div> 
                                </div>
                                <div class="container-list-avatars hide-scrollbar">
                                    <div class="list-avatars hide-scrollbar">
                                        <Tooltip 
                                            v-for="page in draftInstance.pages" 
                                            :text="page.name"
                                            :key="page.id"
                                        >
                                            <Avatar 
                                                :urlPicture="page.avatar" 
                                                :typeNetwork="page.network" 
                                                :checked="draftInstance.form.merge.target.id && draftInstance.form.merge.target.id == page.id"
                                                :edited="!!draftInstance.form.merge.saveAllFormData.pages[page.id]"
                                                @click="()=>draftInstance.form.merge.run(page)"
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </template>
                            
                        </div>          
                        <FormStory 
                            :formData="formData"
                            :updateFormData="pagesSelected.length > 1 && idPageSelected && saveAllFormData.pages[idPageSelected] && saveAllFormData.main.storification[idStorySelected]  ? saveAllFormData.pages[idPageSelected] : {}"
                            :idStorySelected="idStorySelected"
                            :files="files"
                            :tab="tab"
                            :formInstance="draftInstance.form"
                            :storySelected="storySelected"
                            @addFile="(...args)=>this.$emit('addFile',...args)"
                        />
                
                    </div>
                </div>
            </div>
            
            <div class="container-phone" ref="containerPhone">
                <div :class="`nav-stories left`" v-if="tab !== 'story_share'">
                    <div class="list-stories">
                        <draggable 
                            class="list-stories-draggable" 
                            ref="listMedia" 
                            v-model="draftInstance.form.stories.items" 
                            :animation="200"
                            group="description"
                            :disabled="false",
                            ghostClass="ghost"
                            :filter="'.lockdrag'"
                            @change="moveStory"

                        >
                            <transition-group type="transition" :name="'flip-list'">
                                <div class="item" 
                                    v-for="(story, index) in draftInstance.form.stories" 
                                    :class="{
                                        active: index == indexStorySelected, 
                                        disable : story.hide,
                                        lockdrag: indexStorySelected !== index
                                    }" 
                                    @click="selectStory(index)"
                                    :key="index"
                
                                    >
                                    {{index+1}}
                                    <!-- <Tooltip 
                                        v-if="pagesSelected.length > 1 && !previewMode.active && saveAllFormData.main && saveAllFormData.main.storification && !saveAllFormData.main.storification[id]" 
                                        :text="$t('dash.post-creator.story.page-specific')" 
                                        position="right" 
                                        :classCustom="'icon-edited'"
                                    /> -->
                                </div>
                            </transition-group>
                        </draggable>
                        
                        <div class="item" @click="addNewStory" v-if="draftInstance.form.stories.length < 10 && !previewMode.active">
                            <i class="fa-solid fa-plus"></i>
                        </div>
                    </div>
                </div>

                <!-- switch entre post standard ou parte en story dans la preview -->
                <div class="switch-preview-post-type" v-if="previewMode.active && tab == 'story_share'">
                    <div class="" @click.stop="()=>$emit('changeTab','standard')">Standard</div>
                    <div class="btn-primary">Story</div>
                </div>

                <Phone :firstPlan="phoneIsFirstPlan" :showNotch="false">
                    <StoryMaker
                        :formData="formData"
                        :saveAllFormData="saveAllFormData"
                        :idStorySelected="idStorySelected"
                        :deleteStory="deleteStory"
                        :pageSelected="previewMode.active ? previewMode.pageSelected : pagesSelected.find(p => p.id == idPageSelected)"
                        :previewEnabled="previewMode.active"
                        :files="files"
                        :storySelected="storySelected"
                        :formInstance="draftInstance.form"
                    />

                    <selectMention v-if="modes.includes('addMentionMode')" 
                        @close="removeMode" 
                        :position="'left'"
                        :mentionData="dataMode.addMentionMode && dataMode.addMentionMode.mention ? dataMode.addMentionMode.mention : {}"
                        :idMention="dataMode.addMentionMode && dataMode.addMentionMode.idMention ? dataMode.addMentionMode.idMention : null"
                    />
                </Phone>
                <template v-if="previewMode.active">
                    <div class="nav-page-standard" v-if="tab == 'story_share'">
                        <div class="list-page hide-scrollbar">
                            <template v-for="(networkName, index) in listNetworkSort">
                                <div class="group" v-if="pagesSelected.some(p => p.network == networkName)" :key="networkName" :class="{'active': false}">
                                    <div class="network" 
                                        :class="{
                                            [networkName]:true, 
                                            edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                            failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                        }" 
                                    >
                                    </div>
                                    <div class="list-avatar">
                                       
                                        <div class="container-avatar"
                                            v-for="page in pagesSelected.filter(p => p.network == networkName)" 
                                            :class="{
                                                checked: (previewMode.pageSelected && previewMode.pageSelected.id == page.id), 
                                            }"
                                            :key="page.id"
                                        >
                                          
                                            <Avatar 
                                                @click="()=>{
                                                    $emit('changePreviewDisplay',true, page);
                                                    $emit('generateFormData',page)
                                                }" 
                                                :checkIsPossible="true" 
                                                :checked="(previewMode.pageSelected && previewMode.pageSelected.id == page.id)" 
                                                :urlPicture="page.avatar"

                                            />
                                        </div>
                                    </div>
                                </div>   
                            </template>  
                        </div>
                    </div>

                    <div v-else class="nav-page-story hide-scrollbar">
                        <Avatar 
                            v-for="(page, index) in pagesValidForPreview" 
                            :urlPicture="page.avatar" 
                            :typeNetwork="page.network" 
                            :key="page.id+index" 
                            :checked="previewMode.pageSelected && page.id == previewMode.pageSelected.id"
                            @click="()=>{
                                $emit('changePreviewDisplay',true, page);
                                $emit('generateFormData', page)
                            }" 
                        />
                    </div>    
                </template>
                
            </div>          
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import ComponentSwitch from '@/components/dash/utils/switch.vue';
import Avatar from '../utils/avatar.vue';
import Checkbox from '@/components/dash/utils/checkbox.vue';
import Phone from './components/Phone.vue';
import FormStory from './components/storyTab/FormStory.vue';
import StoryMaker from './components/storyTab/StoryMaker.vue';
import selectMention from './components/formOverlay/selectMention.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import draggable from 'vuedraggable'

import { formDataDefault, maxFilesPerNetwork, listNetworkSort } from './constante.js'
import SSE from './../../../utils/sse.js'

import postMixin from '@/components/mixins/Posts.vue'
import draftMixin from '@/components/mixins/Drafts.vue'
import { 
    foreachSaveAllFormData,
    customModeIsAvailable as customModeIsAvailableUtil
 } from './utils.js';

import { VueDraft } from '@mashupweb/draft-lib';
import StoryForm from '@mashupweb/draft-lib/dist/form/story/Form';

export default {
    components: {
        ComponentSwitch,
        Phone,
        FormStory,
        StoryMaker,
        Avatar,
        Checkbox,
        selectMention,
        Tooltip,
        draggable
    },
    mixins: [postMixin, draftMixin],

    props: {
        mode: String,
        tab: String,
        files:Object,
        isFileUploading:Boolean,
        formData: Object,
        saveAllFormData: Object,
        dataFormRequest: Object,
        previewMode: Object,
        idUsersAssigned: {
            type:Array,
            default: ()=>[]
        },
        requiredValidation:Boolean,
        canRestoreDraft:Boolean,
        draftInstance:VueDraft
    },

    data() {
        return {
           
            listNetworkSort: listNetworkSort,
           

            formShow: "formMultiple",// pour l'annimation
            timeOutAnnimateForm: null,

            idStorySelected: "0",
            idPageSelected: null,
            
        

            //la list mode est connu et modifiable par tout les interfaces Network et les deux formulaires 
            modes : [],
            dataMode : {},

            dataFormRequest : {},
            showTutorial : !localStorage.postCreatorCountUseSelectorMode ? true : localStorage.postCreatorCountUseSelectorMode < 3,
            pagesInstagramActivedShareStory: [],
            idsStories: [],
            indexStorySelected: 0,
        }
    },



    created() {
        EventBus.$on('postCreatorAddMode', this.addMode);
        EventBus.$on('postCreatorRemoveMode', this.removeMode);

        if (this.tab == 'story_share') {
            this.setPagesInstagramActivedShareStory()
        }
        this.idStorySelected = Object.keys(this.formData.storification).sort()[0]
    },


    methods: {
        ///////////// METHOD NAVIGATION /////////////

        switchTab() {

            this.$emit("generateFormData")
            this.$emit("changeTab",'standard')
        },

        selectPage(page = null) {
            this.draftInstance.form.merge.run(page)
            return

            if (page) {
                if(!this.idPageSelected)  this.$emit("saveFormData")
                this.idPageSelected = page.id
                this.$emit("generateFormData",page)
            }else{
                this.idPageSelected = null
                this.$emit("generateFormData")
            }

            //Calcul "idStorySelected" pour savoir quelle aperçu de story afficher
            if (!this.formData.storification[this.idStorySelected] || this.formData.storification[this.idStorySelected].hide) {
                const idsStories = Object.keys(this.formData.storification).sort((a, b) => parseInt(a) > parseInt(b))
                this.idStorySelected = idsStories.find(id => !this.formData.storification[id].hide) || idsStories[0]
            }
        },

        async handlerChangePreviewDisplay(state) {
            if (state) {
                const page = this.pagesSelected.find(page => page.network == 'instagram' && (!this.idPageSelected || page.id == this.idPageSelected))
                if (page && !this.isFileUploading) {
                    EventBus.$emit('storyMaker-confirmEditingSticker');
                    await this.$nextTick();
                    this.$emit('changePreviewDisplay', true, page)
                    this.$emit('generateFormData', page)
                }
            }else{
                this.$emit('changePreviewDisplay', false)
                this.selectPage(this.idPageSelected ? this.pagesSelected.find(page => page.id == this.idPageSelected) : null)
            }

        },

        addMode(mode, data = {}) {
            if (!this.modes.includes(mode)) this.modes = [...this.modes,mode]
            this.$set(this.dataMode, mode, data)
        },

        removeMode(mode = 'all') {
            if (mode == 'all') {
                this.modes = []
                return
            }
            this.modes = this.modes.filter(v => v !== mode)
        },

        switchInterface() {
            localStorage.setItem('postCreatorInterfacePreference', 'old')
            this.$router.push({
                name: 'planner',
                params: {
                newPost: true
                }
            })
        },

        openSelectPage() {
            this.$store.commit('selectPage/updateSelectPageListRetracted', false)
        },

        ///////////// METHOD STORY /////////////
        selectStory(index) {
            this.indexStorySelected = index
        },

        addNewStory() {
            if (this.draftInstance.form.stories.length >= 10) return
            this.draftInstance.form.stories.new()
            this.indexStorySelected = this.draftInstance.form.stories.length - 1
        },

        moveStory(e) {
            this.indexStorySelected = e.moved.newIndex
        },

        deleteStory() {
            this.storySelected.remove()
            this.indexStorySelected = Math.max(this.indexStorySelected - 1, 0)
        },

        sortStoriesId() {
            this.idsStories = Object.keys(this.formData.storification).sort((a, b) => parseInt(a) > parseInt(b)) || []
        },

        //////////// METHOD FOR FORMDATA ////////////


        unassignCurrentUser() {
            this.$emit('unassignCurrentUser')
        },

        assignUsers() {
            this.$emit('assignUsers')
        },

        setPagesInstagramActivedShareStory() {

            const customModeIsAvailable = customModeIsAvailableUtil({
                pagesSelected: this.pagesSelected,
                validator: null,
                formDataMain: this.saveAllFormData.main,
                files: this.files,
            })


            console.log("setPagesInstagramActivedShareStory", this.formData.formDataNetwork.instagram.storification.active)
            let defaultActivedShareStory = this.saveAllFormData.main.formDataNetwork.instagram.storification.active

            //regarde si la valeur de storification dans la customisation de instagram
            let saveNetworkIsActiveStory = null

            if (
                customModeIsAvailable &&
                this.saveAllFormData.networks &&
                this.saveAllFormData.networks['instagram'] && 
                this.saveAllFormData.networks['instagram'].formDataNetwork &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification.hasOwnProperty('active')
            ) {
                saveNetworkIsActiveStory =  this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification.active
            }
 
            this.pagesInstagramActivedShareStory = this.pagesSelected.filter(page => {
                if (page.network !== 'instagram') return false
                //verif conciergerie
                if (!page.story_config || !page.story_config.created) return false

                if (
                    customModeIsAvailable &&
                    this.saveAllFormData.pages?.[page.id]?.formDataNetwork?.instagram?.storification?.hasOwnProperty('active')
                ) {
                    return  this.saveAllFormData.pages[page.id].formDataNetwork.instagram.storification.active
                }
              
                if (saveNetworkIsActiveStory !== null) {
                    return  saveNetworkIsActiveStory
                }
                return defaultActivedShareStory
            })

            if (this.pagesInstagramActivedShareStory.length == 0 && this.tab == 'story_share') {
               this.switchTab()
            }

        
        },

        saveDraft() {
            if (this.isFileUploading) return
            EventBus.$emit('storyMaker-confirmEditingSticker');
            this.$nextTick(() => {
      
       
            })
        },

        sendPostAllPost() {
            this.$emit('sendPostAllPost')
        },
     
        
    },

    computed: {
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]).filter(p => p && p.network == 'instagram' && (this.tab !== "story_share" || (p.story_config && p.story_config.created)));
        },
       
        phoneIsFirstPlan() {
            let validmodes = ['addCollaboratorMode','addIdentifierMode','addPlaceMode', 'addMusicMode','addMentionMode','addHashtagMode']
            return validmodes.find(v => this.modes.includes(v)) ? true : false
        },

        form() {
            if (!this.isSharedStory) {
                return this.draftInstance.form
            }
        },

        isSharedStory() {
            return !(this.draftInstance.form instanceof StoryForm)
        },

        storySelected() {
            return this.form.stories[this.indexStorySelected]
        },



        


        // textContentConverted() {
    
        //     const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
        //     if (!this.formData.textContent || regex.test( this.formData.textContent)) return ''
            
        //     return this.formData.textContent.replaceAll("\\n", '<br>')
        // },

        // textCommentConverted() {
        //     const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
        //     if (!this.formData.comments[0] || regex.test( this.formData.comments[0])) return ''

        //     return this.formData.comments[0] ? this.formData.comments[0].replaceAll("\\n", '<br>') : ''
        // },

        countDataFormRequestValid() {
            return Object.values(this.dataFormRequest).filter(form => !form.hasOwnProperty('error')).length
        },

        isCurrentUserAssigned() {
            return (
                this.formData.planifiedDate.date && 
                this.idUsersAssigned.length && 
                this.requiredValidation && 
                this.idUsersAssigned.includes(this.currentUser.id)
            )
        },
        

        textSwitchPreview() {

            if (this.formData.planifiedDate.date && this.idUsersAssigned.length && this.requiredValidation ) {
                if (this.isCurrentUserAssigned) {
                    return this.$t('dash.post-creator.action.validate')
                }else{
                    return this.$t('dash.post-creator.action.send-for-validation')
                }

            }
            if (this.mode == 'edit') return this.$t('dash.post-creator.action.apply')
            let postPlanified = false
            let postInstantly = false

            const formMain = !this.idPageSelected ? this.formData : this.saveAllFormData.main

            for (let i = 0; i < this.pagesSelected.length; i++) {
                if (postPlanified && postInstantly) break;
                const page = this.pagesSelected[i];

                const formDataByPage = this.idPageSelected  && this.idPageSelected  == page.id ? this.formData : this.saveAllFormData.pages[page.id]


                if (formDataByPage && formDataByPage.planifiedDate) {
                    if (formDataByPage.planifiedDate.date || formDataByPage.planifiedDate.hours) {
                        postPlanified = true
                    }else {
                        postInstantly = true
                    }
                }else{

                    if (formMain.planifiedDate.date || formMain.planifiedDate.hours) {
                        postPlanified = true
                    } else {
                        postInstantly = true
                    }
                }
            }

            if (postPlanified && postInstantly) {
                return this.$t('dash.post-creator.action.publish-and-schedule')
            } else if (postPlanified) {
                return this.$t('dash.button.schedule')
            } else if (postInstantly) {
                return this.$t('dash.post-creator.action.publish')
            }

            return '';
        },

        textBtnFinish() {
            if (this.formData.planifiedDate.date && this.idUsersAssigned.length && this.requiredValidation) {
                if (this.idUsersAssigned.includes(this.currentUser.id)) {
                    return this.$t('dash.post-creator.action.validate')
                }else{
                    return this.$t('dash.post-creator.action.send-for-validation')
                }

            }
            const forms = Object.values(this.dataFormRequest);

            const postPlanified = forms.filter(form => !form.hasOwnProperty('error') && form["data[scheduled_date]"]);
            const postInstantly = forms.filter(form => !form.hasOwnProperty('error') && !form["data[scheduled_date]"]);

            if (postPlanified.length && postInstantly.length) {
                return this.$t('dash.post-creator.action.publish-and-schedule')
            } else if (postPlanified.length) {
                return `${this.$t(postPlanified.length > 1 ? 'dash.post-creator.action.schedule-on-pages' : 'dash.post-creator.action.schedule-on-page', { count: postPlanified.length })}`;
            } else if (postInstantly.length) {
                return `${this.$t(postInstantly.length > 1 ? 'dash.post-creator.action.publish-on-pages' : 'dash.post-creator.action.publish-on-page', { count: postInstantly.length })}`;
            }

            return '';
        },

        pagesValidForPreview() {
            return this.pagesSelected.filter(page => {
                if (!this.saveAllFormData.pages[page.id] || !this.saveAllFormData.pages[page.id].storification) return true
                
                const amountNewStory = Object.keys(this.saveAllFormData.pages[page.id].storification).filter(idStory => !this.saveAllFormData.main.storification[idStory]).length
                const amountStoryHide =  Object.values(this.saveAllFormData.pages[page.id].storification).filter(story => story.hide).length
                if (Object.keys(this.saveAllFormData.main.storification).length + amountNewStory > amountStoryHide) return true
                return false
            })
        },

        title () {

            switch (this.mode) {
                case "edit":
                    return this.$t('dash.post-creator.title.edit-mode')
                case "draft":
                    return this.$t('dash.post-creator.title.draft')

                default:
                    return this.previewMode.active ? this.$t('dash.post-creator.title.preview') : this.$t('dash.post-creator.title.new')

            }


        }
    },

    watch: {

        ["previewMode.active"]: {
            handler(value, oldValue) {
                console.log('watch previewMode.active',value, oldValue)
                if (value) {
                    // if (this.previewMode.pageSelected) this.toggleSelectPageForcustomMode(this.previewMode.pageSelected)
                    if (oldValue == undefined && this.tab == 'story_share') {
                        this.formShow = "preview-right annimate-switch-preview-mode"
                    }else{
                        this.formShow = "preview-right"
                        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                        this.$nextTick(() => {
                            this.timeOutAnnimateForm = setTimeout(() => {
                                this.$refs.postCreator.classList.add('annimate-switch-preview-mode');
                            }, 500);
                        })
                    }
                }else{
                    this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');
                    if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                    this.$nextTick(() => {
                        this.timeOutAnnimateForm = setTimeout(() => {
                             this.formShow = "formMultiple"
                        }, 1000);
                    })
                }
            },
            immediate: true
        },
        pagesSelected: {
            handler(pages, oldPages) {
                console.log("watch pagesSelected", {pages, oldPages})
                if (pages.length == 1){
                    if (oldPages == undefined || oldPages.length !== 1) {
                        this.selectPage(pages[0])
                    }
                }else if (pages.length > 1 && oldPages && oldPages.length == 1) {
                    console.log("migratePageSaveInMainSave")
         
                    this.$emit('migratePageSaveInMainSave', oldPages[0].id)
                    this.selectPage()
                }
                if (this.tab == 'story_share') {
                    this.setPagesInstagramActivedShareStory()
                }
            },
            immediate : true
        },
       
        ['formData.storification']: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.sortStoriesId()
            }
        }
        
    },

    beforeDestroy () {
        
        EventBus.$off('postCreatorAddMode', this.addMode);
        EventBus.$off('postCreatorRemoveMode', this.removeMode);
        EventBus.$off('deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);


    }

}
</script>
